/**
 * @desc 管理员界面
 */

import React, { PureComponent } from 'react';
// import classNames from 'classnames';
import { Table, Popconfirm } from 'antd';
import { AccountStatus } from '../../constants/enum';
import { AccountStatusText, AccountTypeText } from '../../constants/info';
import GroupBox from '../common/groupBox/GroupBox';
import Pagination from '../common/pagination/Pagination';
import messager from '../../utils/messager';
import { paramFilter } from '../../utils/util';
import SearchForm from './index/SearchForm';
import AddAccount from './index/AddAccount';
import { getUserList, resetUserPwd, enableUser, disableUser, addUser } from '../../services/user';

export default class PersonalIndex extends PureComponent {
    constructor(props) {
        super(props);
        this.statusColor = {
            [AccountStatus.ENABLE]: 'green-font',
            [AccountStatus.DISABLE]: 'red-font'
        };
        this.statusColorAntonym = {
            [AccountStatus.ENABLE]: 'red-font',
            [AccountStatus.DISABLE]: 'green-font'
        };
        this.statusTextAntonym = {
            [AccountStatus.ENABLE]: '禁用',
            [AccountStatus.DISABLE]: '启用'
        };
        this.state = {
            searchParams: {},
            pageNum: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            tableData: [],
            visible: false,
            modalKey: +new Date()
        };
    }

    onSearch = (params) => {
        this.setState({
            searchParams: params,
            pageNum: 1,
            total: 0
        }, () => {
            this.getData();
        });
    };

    getData = () => {
        let { pageNum, pageSize, searchParams } = this.state;

        this.setState({
            loading: true
        });
        getUserList(paramFilter({ pageNum, pageSize, ...searchParams })).then(data => {
            this.setState({
                loading: false,
                tableData: data.list || [],
                total: data.total || 0
            });
        }).catch(() => {
            this.setState({
                loading: false,
                tableData: []
            });
        });
    };

    // 分页
    pageChange = (pageNum, pageSize) => {
        this.setState({
            pageNum,
            pageSize
        }, this.getData);
    };

    // 弹框操作
    showModal = () => {
        this.setState({ visible: true, modalKey: +new Date() });
    };

    hideModal = () => {
        this.setState({ visible: false });
    };

    // 新增或编辑
    modifyAccount = (params) => {
        addUser(params).then(() => {
            messager.success('添加成功');
            this.hideModal();
            this.getData();
        });
    };

    // 启用或禁用
    toggleEnable = (d) => {
        let server = d.status === AccountStatus.ENABLE ? disableUser : enableUser;
        server({ id: d.id }).then(() => {
            messager.success('操作成功');
            this.getData();
        });
    }

    // 重置密码
    resetPwd = (d) => {
        resetUserPwd({ id: d.id }).then(() => {
            messager.success('重置成功');
        });
    };

    getColumns = () => {
        return [{
            title: '姓名',
            dataIndex: 'name',
            width: 150
        }, {
            title: '部门',
            dataIndex: 'department',
            width: 200
        }, {
            title: '账号',
            dataIndex: 'userName',
            width: 160
        }, {
            title: '账号类型',
            dataIndex: 'type',
            width: 110,
            render: (v) => AccountTypeText[v]
        }, {
            title: '邮箱',
            dataIndex: 'emailAdress'
        }, {
            title: '账号状态',
            dataIndex: 'status',
            width: 100,
            render: (v) => <span className={this.statusColor[v]}>已{AccountStatusText[v]}</span>
        }, {
            title: '操作',
            dataIndex: 'operation',
            width: 150,
            render: (v, d) => <div className="operation">
                <Popconfirm title={`确定${this.statusTextAntonym[d.status]}该账号？`} onConfirm={() => this.toggleEnable(d)}>
                    <a href="javascript:void(0)" className={this.statusColorAntonym[d.status]}>{this.statusTextAntonym[d.status]}</a>
                </Popconfirm>
                <Popconfirm title="确定重置密码？" onConfirm={() => this.resetPwd(d)}>
                    <a href="javascript:void(0)" className="orange-font">重置密码</a>
                </Popconfirm>
            </div>
        }];
    };

    render() {
        const { pageNum, pageSize, total, tableData, loading, modalKey, visible } = this.state;

        return (
            <div className="base-panel">
                <GroupBox
                    title="管理员界面"
                >
                    <SearchForm onSearch={this.onSearch} handleCreate={this.showModal}/>

                    <Table
                        rowKey="id"
                        loading={loading}
                        pagination={false}
                        columns={this.getColumns()}
                        dataSource={tableData}
                        bordered
                        footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>}
                    />
                    <AddAccount
                        key={modalKey}
                        visible={visible}
                        onCancel={this.hideModal}
                        onConfirm={this.modifyAccount}
                    />
                </GroupBox>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Index.jsx